// Mock data for Visaspot website

export const services = [
  {
    id: 1,
    title: "Study Abroad Consulting",
    description: "Expert guidance for students aspiring to pursue education overseas. We help you choose the right university and course.",
    image: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc",
    icon: "GraduationCap"
  },
  {
    id: 2,
    title: "Immigration & Visa Services",
    description: "Comprehensive immigration solutions for individuals and families. Navigate complex visa processes with confidence.",
    image: "https://images.unsplash.com/photo-1743193143977-bc57e2c100ad",
    icon: "Plane"
  },
  {
    id: 3,
    title: "Student Visa Assistance",
    description: "Specialized support for student visa applications. Maximize your chances of approval with our expert guidance.",
    image: "https://images.unsplash.com/photo-1573164574511-73c773193279",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Work Permit & PR Services",
    description: "Professional assistance for work permits and permanent residency applications. Build your future abroad.",
    image: "https://images.pexels.com/photos/7794036/pexels-photo-7794036.jpeg",
    icon: "Briefcase"
  }
];

export const countries = [
  {
    id: 1,
    name: "Canada",
    description: "World-class education and immigration opportunities",
    image: "https://images.unsplash.com/photo-1668882698355-923d532fa985",
    programs: "500+ Universities",
    visaSuccess: "95%"
  },
  {
    id: 2,
    name: "USA",
    description: "Premier destination for higher education and careers",
    image: "https://images.unsplash.com/photo-1648595837528-9bdd1dd2143a",
    programs: "700+ Universities",
    visaSuccess: "92%"
  },
  {
    id: 3,
    name: "United Kingdom",
    description: "Excellence in education with rich cultural heritage",
    image: "https://images.unsplash.com/photo-1745016176874-cd3ed3f5bfc6",
    programs: "400+ Universities",
    visaSuccess: "94%"
  },
  {
    id: 4,
    name: "Australia",
    description: "Quality lifestyle with excellent education standards",
    image: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8",
    programs: "350+ Universities",
    visaSuccess: "93%"
  },
  {
    id: 5,
    name: "Europe",
    description: "Diverse opportunities across European nations",
    image: "https://images.unsplash.com/photo-1570097703229-b195d6dd291f",
    programs: "600+ Universities",
    visaSuccess: "91%"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    country: "Canada",
    university: "University of Toronto",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    rating: 5,
    text: "Visaspot made my dream of studying in Canada a reality. Their guidance throughout the application process was invaluable. Highly recommended!"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    country: "Australia",
    university: "University of Melbourne",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    rating: 5,
    text: "Professional, knowledgeable, and supportive. The team helped me navigate the complex visa process with ease. Thank you Visaspot!"
  },
  {
    id: 3,
    name: "Ananya Patel",
    country: "UK",
    university: "University of Oxford",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
    rating: 5,
    text: "Excellent service from start to finish. They helped me secure admission to my dream university in the UK. Forever grateful!"
  }
];

export const stats = [
  { label: "Students Placed", value: "10,000+", icon: "Users" },
  { label: "Visa Success Rate", value: "95%", icon: "CheckCircle" },
  { label: "Partner Universities", value: "500+", icon: "Building" },
  { label: "Countries Covered", value: "25+", icon: "Globe" }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Guidance",
    description: "Certified counselors with years of experience in overseas education and immigration",
    icon: "Award"
  },
  {
    id: 2,
    title: "End-to-End Support",
    description: "From course selection to visa approval, we're with you every step of the way",
    icon: "Shield"
  },
  {
    id: 3,
    title: "High Success Rate",
    description: "95% visa approval rate backed by proven processes and expertise",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Transparent Process",
    description: "Clear communication, no hidden fees, and complete transparency throughout",
    icon: "Eye"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the student visa process take?",
    answer: "The timeline varies by country, but typically ranges from 4-12 weeks. We help expedite the process with proper documentation and guidance."
  },
  {
    id: 2,
    question: "What are the eligibility criteria for study abroad?",
    answer: "Eligibility depends on the country and program. Generally, you need academic qualifications, English proficiency (IELTS/TOEFL), and financial proof. Our experts assess your profile during the free consultation."
  },
  {
    id: 3,
    question: "Do you help with scholarship applications?",
    answer: "Yes! We guide students through scholarship opportunities and assist with applications to maximize your chances of financial aid."
  },
  {
    id: 4,
    question: "What is your success rate for visa approvals?",
    answer: "We maintain a 95% success rate across all countries. Our experienced team ensures complete documentation and preparation for visa interviews."
  },
  {
    id: 5,
    question: "Can I work while studying abroad?",
    answer: "Most countries allow international students to work part-time (15-20 hours/week) during studies. We provide complete information about work rights in your destination country."
  }
];
